import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import $ from 'jquery';  // Import jQuery (if it's not already available)
import 'jquery-confirm';
import moment from 'moment';
import api from '../../api/axiosInstance';
const FormCard = ({ title, forms, handleDelete, handleActivate, handleExpiryDate,handleSetPublished,copyFormMaster,openCreateFormModal}) => {
debugger;
 const tableId = title.replace(/\s+/g, '') + "Table"; 
  const [selectedFormId, setSelectedFormId] = useState(''); // Store the form ID for which expiry date is set
  const [expiryDate, setExpiryDate] = useState(''); // Store selected expiry date
      const [loading, setLoading] = useState(true);
  // const sortedForms = forms.sort((a, b) => new Date(b.modifiedOn) - new Date(a.modifiedOn));
debugger;
  // Initialize date picker on component mount
  const isValidDate = (date) => {
  if (!date) return false;
  const d = new Date(date);
  if (isNaN(d.getTime())) return false; // removes 0001-01-01
  return true;
};

// Filter out all forms where date fields are 1/1/1
const filteredForms = forms.filter(form => {
  // For Published Forms → check expiryDate & publishedOn
  if (title === 'Published Forms') {
    return isValidDate(form.expiryDate) && isValidDate(form.publishedOn);
  }

  // For Approved Forms → check approvedOn
  if (title === 'Approved Forms') {
    return isValidDate(form.approvedOn);
  }


  return true; // default allow
});


useEffect(() => {
  if (forms.length === 0) return;

  const table = window.$(`#${tableId}`).DataTable({
    responsive: true,
    autoWidth: false,
    searching: true,
    ordering: true,
    pageLength: 10,
    lengthChange: false,
    paging: true,
    info: true,
    destroy: true, // IMPORTANT: avoids reinitializing problem
  });

  return () => {
    table.destroy();
  };
}, []);

// Then sort
const sortedforms = filteredForms.sort(
  (a, b) => new Date(b.modifiedOn) - new Date(a.modifiedOn)
);


  useEffect(() => {
    if (window.$) {
      // Initialize datetimepicker with Moment.js
      window.$('#reservationdate').datetimepicker({
        format: 'YYYY-MM-DD', // The format you want to display
        minDate: moment().add(1, 'days'), // Minimum date is tomorrow
        maxDate: moment().add(5, 'years') // Maximum date is 5 years from now
      });

      // Set the initial expiry date value when the modal is opened
      window.$('#reservationdate').on('change.datetimepicker', function (e) {
        debugger;
        setExpiryDate(e.date ? moment(e.date).format('YYYY-MM-DD') : ''); // Update expiryDate state
      });
    }
  }, []);

  // Open the modal and set the form ID for which expiry date is being set
  const openSetExpiryDateModal = (formId, currentExpiryDate) => {debugger;
    // formattedFormId = formId.toString();

  localStorage.setItem('currentformId',formId);
    setExpiryDate(currentExpiryDate); // Set the current expiry date for the form
  };

  // Handle saving the expiry date
  const handleSaveExpiryDate = (expiryDate) => {debugger;
    if (!expiryDate) {
      $.alert('Expiry Date is required');
      return;
    }
  const formId = localStorage.getItem('currentformId');
  localStorage.removeItem('currentformId');
    const selectedDate = new Date(expiryDate);
    const currentDate = new Date();
  
    // Ensure the expiry date is a future date
    if (selectedDate <= currentDate) {
      $.alert('Expiry Date must be a future date.');
      return;
    }

 handleExpiryDate(formId, selectedDate); // Correctly invoke the function
      // $('#modal-sm').modal('hide');
      const modal = document.getElementById('modal-sm');
      modal.style.display = 'none'; // Close the modal
           const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
          backdrop.remove();
      }
           document.body.classList.remove('modal-open');
           setExpiryDate('');

  };
   // Handle saving the expiry date
   const passHandleSetPublished = (formId) => {debugger;
    if (!formId) {
      $.alert('form Id is required');
      return;
    }
    handleSetPublished(formId); // Correctly invoke the function
  };
  const handleCopyFormMaster = (formId) => {debugger;
    if (!formId) {
      $.alert('form Id is required');
      return;
    }
     copyFormMaster(formId); // Correctly invoke the function
  };
  const handleCopyFormMasterLink =(formId) => {
    debugger;
    const link=`http://localhost:3000/editor/GenerateExternalForm/${formId}`;
     navigator.clipboard.writeText(link)
      .then(() => {
        // $.alert("External Form URL Copied Successfully!");
                      $.alert({
                        title: 'Success',
                        content: 'External Form URL Copied Successfully!',
                        type: 'green'
                      });
      })
      .catch(err => {
        $.alert("Failed to copy the link");
      });
    // get the link of formMasterView Page and copied them 
  }

  
  return (
    <div className="card card-success" style={{ marginTop: '5px' }}>
      <div className="card-header">
        <h3 className="card-title" style={{fontSize:'1rem'}}>{title}</h3>
      </div>
      <div className="card-body">
        { title=== 'In-Progress Forms' &&
         <button className="btn btn-success btn-sm" onClick={openCreateFormModal}>New</button> 
        }
        <table id={tableId} className="table table-bordered table-striped" style={{ marginTop: '5px' }}>
          <thead>
            <tr>
              <th width="20%">Name</th>
              <th width="23%">Category</th>
              <th width="22%">Sub-Category</th>
              {(title === 'Approved Forms' || title === 'In-Progress Forms') && <th>Created On</th>}
              {title === 'Expired Forms' && <th width="12%">Published On</th>}
              <th width="12%">
                {title === 'Published Forms' 
                  ? 'Published On' 
                  : title === 'Expired Forms' 
                  ? 'Expired On' 
                  : title === 'Approved Forms' 
                  ? 'Approved On' 
                  : 'Status'}
              </th>
              {title === 'Published Forms' && <th width="10%">Expiry Date</th>}
              <th width="12%">Action</th>
            </tr>
          </thead>
          <tbody>
          {(!forms || forms.length === 0) ? (
    <tr>
      <td colSpan="7" style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', color: 'gray' }}>
        No Forms Available
      </td>
    </tr>
  ) : (
            sortedforms.map(form => (
              <tr key={form.id}>
                <td>{form.name}</td>
                <td>{form.formCategoryName}</td>
                <td>{form.formSubCategoryName}</td>
                {(title === 'Approved Forms' || title === 'In-Progress Forms') && <td>{new Date(form.createdOn).toLocaleDateString()}</td>}
                {title === 'Expired Forms' && <td>{!isValidDate(form.expiryDate) ? '': new Date(form.expiryDate).toLocaleDateString()}</td>}
                <td>
                  {title === 'Published Forms' 
                    ? !isValidDate(form.publishedOn) ? "": new Date(form.publishedOn).toLocaleDateString()

                    : title === 'Expired Forms' 
                    ? !isValidDate(form.expiryDate) ? "": new Date(form.expiryDate).toLocaleDateString()
                    : title === 'Approved Forms' 
                    ?!isValidDate(form.approvedOn) ? "":  new Date(form.approvedOn).toLocaleDateString() 
                    : form.statusReasonText}
                </td>
                {title === 'Published Forms' && <td>{ (new Date(form.expiryDate).getFullYear() <= 1) ? "":new Date(form.expiryDate).toLocaleDateString()}</td>}
                <td>
                  <Link to={`/editor/FormMastersView/${form.id}`} className="btn btn-xs btn-success" title="View">
                    <i className="fa fa-eye"></i>
                  </Link>
                   &nbsp;
                  <button className="btn btn-xs btn-danger"
                    onClick={() => {
                      $.confirm({
                        title: 'Confirm Deletion',
                        content: 'Do you really want to delete this?',
                        type: 'red',
                        buttons: {
                          confirm: {
                            text: 'Yes',
                            btnClass: 'btn-red',
                            action: function () {
                              handleDelete(form.id); // Call handleDelete from parent
                            }
                          },
                          cancel: {
                            text: 'No',
                            btnClass: 'btn-default',
                          }
                        }
                      });
                    }}
                    
                    title="Delete">
                    <i className="fa fa-trash"></i>
                  </button>
                  &nbsp;
                  {title === 'In-Progress Forms' || title === 'Approved Forms' || title === 'Published Forms' ? (
                    <button className="btn btn-xs btn-warning" title="Copy"
                    onClick={() => {
                              handleCopyFormMaster(form.id); // Call handleDelete from parent
                    }}>
                      <i className="fa fa-copy"></i>
                    </button>
                    
                  ) : null}
              &nbsp;
                    {title === 'Published Forms' && form.formTypeText==='External'? (
                 <button className="btn btn-xs btn-warning" title="CopyExternalLink"
                    onClick={() => {
                              handleCopyFormMasterLink(form.id); // Call handleDelete from parent
                    }}>
                      <i className="fa fa-copy"></i>
                    </button>
          ): null }

                   { title === 'Approved Forms'  ? (
                    <button className="btn btn-xs btn-primary" title="Publish" 
                    onClick={() => {debugger;
                    
                             
                              passHandleSetPublished(form.id); // Safely call handlePublish
                             
                              // handlePublish(form.id); // Call handlePublish from parent
                           
                    }}>
                      <i className="fa fa-book"></i>
                    </button>
                  ) : null}
                  {title === 'Published Forms' && (
                    <button type="button" className="btn btn-default btn-xs btn-primary" title="Set Expiry Date"
                      data-toggle="modal" data-target="#modal-sm" onClick={() => openSetExpiryDateModal(form.id, form.expiryDate)}>
                      <i className="fa fa-clock"></i>
                    </button>
                  )}
                  {title === 'Expired Forms' && (
                    <button className="btn btn-xs btn-primary"
                      title="Activate"
                      onClick={() => handleActivate(form.id)}>
                      <i className="fa fa-check"></i>
                    </button>
                  )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="modal fade" id="modal-sm">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Set Expiry Date</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Date:</label>
                <div className="input-group date" id="reservationdate" data-target-input="nearest">
                
                  <input
                    type="text"
                    className="form-control datetimepicker-input"
                    data-target="#reservationdate"
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)} // Update expiry date state
                    placeholder="Select expiry date"
                  />
                  <div className="input-group-append" data-target="#reservationdate" data-toggle="datetimepicker">
                    <div className="input-group-text">
                      <i className="fa fa-calendar" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-default" data-dismiss="modal">
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={() => handleSaveExpiryDate(expiryDate)}>
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
};

export default FormCard;
